import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';
import { getChangesetErrorsForProperty } from 'donor-elf-web/lib/changeset-utils';

interface ComponentArgs {
  changeset: any;
  property: string;
  label: string;
  showValidationErrors: boolean;
  tabindex?: string; // can set to '-1' to disable tabbing to it
  onChange: (val: boolean) => void;
}

export default class extends Component<ComponentArgs> {
  handleChange = (checkedVal: boolean) => {
    this.args.changeset.set(this.args.property, checkedVal);
    this.args.onChange?.(checkedVal);
  }

  get errorMessage() {
    return getChangesetErrorsForProperty(this.args.changeset, this.args.property)?.join(', ');
  }

  get showError() {
    return this.args.showValidationErrors && isPresent(this.errorMessage);
  }
}
